var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddItemBanner2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -5,
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#DCF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 30C31.6666 30.75 31.0416 31.375 30.3333 31.375H24.3333V37.375C24.3333 38.0834 23.7083 38.6667 23 38.6667C22.25 38.6667 21.6666 38.0834 21.6666 37.375V31.375H15.6666C14.9166 31.375 14.3333 30.75 14.3333 30C14.3333 29.2917 14.9166 28.7084 15.6666 28.7084H21.6666V22.7084C21.6666 21.9584 22.25 21.3334 23 21.3334C23.7083 21.3334 24.3333 21.9584 24.3333 22.7084V28.7084H30.3333C31.0416 28.6667 31.6666 29.2917 31.6666 30Z",
    fill: "#07A69C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItemBanner2);
export default __webpack_public_path__ + "static/media/add_item_banner2.27dba74bef66954525d8fdee97d5b01b.svg";
export { ForwardRef as ReactComponent };